import { useCallback } from "react";
import { ScrollView } from "react-native";
import { useLocalSearchParams } from "expo-router";
import { Text, View } from "@src/components";
import { sizes } from "@src/constants/sizes";
// @ts-expect-error baseline 2026-02-16
import { ReportsSection, ReportsListItem, ReportsListItemText } from "@src/components/web";
import { useRegionConfig } from "@src/hooks/useRegionConfig";
import { isWeb } from "@src/utils/web-helpers";
import { FeatureGate } from "@src/services/feature-flags/FeatureGate";
import { FEATURE_FLAGS } from "@src/services/feature-flags/feature-flags";

export default function ReportsScreen() {
  const { tenantId } = useLocalSearchParams<{ tenantId: string }>();
  const { contactUrl } = useRegionConfig();

  const handleOpenContact = useCallback(() => {
    if (isWeb) {
      window.open(contactUrl, "_blank");
    }
  }, [contactUrl]);

  if (!isWeb) {
    return (
      <View flex={1} alignItems="center" justifyContent="center" padding="3xl" gap="md">
        <Text textStyle="sm/semibold" color="text" textAlign="center">
          Reports are only available on the web client.
        </Text>
        <Text textStyle="xs/regular" color="textMuted" textAlign="center">
          Open this page in your browser to view your reports.
        </Text>
      </View>
    );
  }

  const base = `/tenants/${tenantId}/reports`;

  return (
    <ScrollView
      style={{ flex: 1 }}
      contentContainerStyle={{
        paddingTop: 40,
        paddingBottom: 40,
        paddingHorizontal: 80,
        maxWidth: sizes.webContentMaxWidth,
      }}
      showsVerticalScrollIndicator={false}
    >
      <View gap="6xl">
        <ReportsSection title="Reports">
          <ReportsListItem title="WasteSense" href={`${base}/wastesense`}>
            <ReportsListItemText>A digest of illegal dumping and site activity.</ReportsListItemText>
            <ReportsListItemText>
              Provides a clear answer to: &ldquo;Did anything happen on our site?&rdquo;
            </ReportsListItemText>
          </ReportsListItem>
          <FeatureGate flag={FEATURE_FLAGS.REPORTS_ROADSENSE}>
            <ReportsListItem title="RoadSense" href={`${base}/roadsense`}>
              <ReportsListItemText>A clear picture of vehicle flow and traffic insights.</ReportsListItemText>
              <ReportsListItemText>
                Know exactly who and what moved through your site &mdash; and when.
              </ReportsListItemText>
            </ReportsListItem>
          </FeatureGate>
        </ReportsSection>

        <ReportsSection title="Coming soon">
          <ReportsListItem title="LoadSense" onPress={handleOpenContact} showChevron={false} />
        </ReportsSection>
      </View>
    </ScrollView>
  );
}
